var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.candidate
    ? _c(
        "Sidesheet",
        { attrs: { active: _vm.active }, on: { close: _vm.closeSidesheet } },
        [
          _c("StatusHeader", {
            attrs: { candidate: _vm.candidate },
            on: { close: _vm.closeSidesheet },
          }),
          _c(
            "div",
            { staticClass: "wrapper" },
            [
              _c(
                "div",
                { staticClass: "tabs" },
                [
                  _c("Tabs", {
                    attrs: { active: _vm.activeTab, items: _vm.tabItems },
                    on: {
                      change: function ($event) {
                        _vm.activeTab = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.activeTab === "history"
                ? _c("History", {
                    attrs: {
                      "candidate-info": _vm.candidateInfo,
                      "loading-candidate-info": _vm.loadingCandidateInfo,
                    },
                  })
                : _vm._e(),
              _vm.activeTab === "documents"
                ? _c("Documents", {
                    attrs: {
                      "candidate-files": _vm.candidateInfo.files
                        ? _vm.candidateInfo.files
                        : [],
                      "candidate-id": _vm.candidateInfo.id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }